<template>
  <div>
    <!-- 修改数量弹窗 -->
    <el-dialog :title="dialogTitle" :close-on-click-modal="false" :visible.sync="delDialogVisible" width="1500px" center>
      <div class="rowBox">
        <!-- *修改原因 -->
        <div class="label">
          {{ $t('message.updateReason') }}:
        </div>

        <div class="val">
          <el-input type="textarea" v-model="datas.update_reason"></el-input>
        </div>
        <div class="btn">
          <!-- 修改需要操作数量 -->
          <el-button type="primary" v-if="updateType == 'should'" @click="updateShouldDetail">
            {{ $t("message.commitChanges") }}
          </el-button>
          <!-- 修改实际完成数量 -->
          <el-button type="primary" v-else @click="updateCompleteDetail">
            {{ $t("message.commitChanges") }}
          </el-button>
        </div>
      </div>
      <div class="table">
        <!-- 无数据显示 -->
        <div class="noData" v-if="tableData == false">暂无数据</div>
        <!-- 订单详情 -->
        <div class="detail" v-for="(orderItem, index) in tableData" :key="index">

          <div class="orderDetailOpt">
            <ol>
              <!--  订单号-->
              <li class="flex15">
                {{ $t("message.orderNumber") }}
              </li>
              <!-- 番号 -->
              <li class="flex05">{{ $t("message.mash") }}</li>
              <!--照片-->
              <li>
                {{ $t("message.pic") }}
              </li>
              <!-- 业务编辑商品属性 -->
              <li class="flex15">{{ $t("message.theBusinessEditsTheCommodityProperties") }}</li>
              <!-- 购买信息 -->
              <li>{{ $t("message.purchaseInformation") }}</li>
              <!-- 附加服务 -->
              <li class="flex15">{{ $t("message.additionalServices") }}</li>
              <!-- 担当备注 -->
              <li class="flex15">
                {{ $t("message.responsibleForRemarks") }}
              </li>
              <!-- 核查员备注 -->
              <li class="flex15">
                {{ $t("message.verifierSNotes") }}
              </li>
              <!-- 操作内容-需要操作数量 -->
              <li class="flex3">
                {{ updateType == 'should' ? $t('message.operationContentNeedsOperationQuantity') : '操作内容-需要操作数量-实际操作数量' }}
              </li>
              <!-- 检品组长备注 -->
              <li class="flex15">
                {{ $t("message.inspectionLeaderRemark") }}
              </li>
              <!-- 操作人员备注 -->
              <li class="flex15">
                {{ $t("message.operationPersonnelRemark") }}
              </li>

            </ol>
            <ul v-for="(goodsItem, indexs) in orderItem.option_service_detail" :key="indexs">
              <!--  订单号-->
              <li class="flex15">
                <router-link :to="'/orderPaymentDetail?order_sn=' + goodsItem.order_detail.order_sn" target="_blank"
                  class="a-link">{{ goodsItem.order_detail.order_sn }}</router-link>
              </li>
              <li class="flex05">
                {{ goodsItem.order_detail.sorting }}
              </li>
              <!--照片-->
              <li>
                <div>
                  <div class="img">
                    <el-popover placement="right" width="300" trigger="hover">
                      <img :src="goodsItem.order_detail.pic" alt="" style="width: 300px; height: 300px" />

                      <a :href="goodsItem.order_detail.link.goods_url" target="_blank" slot="reference">
                        <img :src="goodsItem.order_detail.pic" alt="" />
                      </a>
                    </el-popover>
                  </div>
                </div>
              </li>
              <!-- 商品属性 -->
              <li class="flex15">
                <div class="template">
                  <p v-for="(skuItem, skuIndex) in goodsItem
                    .order_detail.detail_y" :key="skuIndex">
                    <span>{{ skuItem.key }}:</span>
                    <span>{{ skuItem.value }}</span>
                  </p>
                </div>
              </li>
              <!-- 购买信息 -->
              <li>
                <div class="template">
                  <p>数量：{{ goodsItem.order_detail.confirm_num }}</p>
                  <p>单价：{{ goodsItem.order_detail.confirm_price }}</p>
                </div>
              </li>
              <!-- 附加服务 -->
              <li class="flex15">
                <div class="template">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(opti, optiIndex) in goodsItem
                        .order_detail.option" :key="optiIndex" style="margin-bottom: 3px">
                        <p>
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                    <div style=" max-height: 150px; overflow: hidden;">
                      <div class="row" v-for="(opti, optiIndex) in goodsItem
                        .order_detail.option" :key="optiIndex">
                        <p>
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }}</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!-- 担当备注 注:担当就是业务员-->
              <li class="flex15">
                {{ goodsItem.order_detail.y_remark }}
              </li>
              <!-- 核查员备注 注:核查员就是配货-->
              <li class="flex15">
                {{ goodsItem.order_detail.p_remark }}
              </li>
              <!-- 变更需要操作数量时不展示实际操作数。 -->
              <li class="flex3">
                <div class="template option">
                  <div class="row" v-for="(extra, extraIndex) in goodsItem.extra_options" :key="extraIndex">
                    <div class="label">{{ extra.name }}:</div>
                    <div class="input" v-if="updateType == 'should'">
                      <el-input v-model="extra.should" placeholder="数量" @input="handleInput(extra, 'should')"></el-input>
                    </div>
                    <template v-else>
                      <div class="num">{{ extra.should }}</div>
                      <div class="input">
                        <el-input v-model="extra.complete" placeholder="数量" @input="handleInput(extra, 'complete')"></el-input>
                      </div>
                    </template>
                  </div>
                </div>
              </li>
              <!-- 检品组长备注 -->
              <li class="flex15">
                <optionServiceRemark :detail="goodsItem" field="leader_remark" />
              </li>
              <!-- 操作人员备注 -->
              <li class="flex15">
                <optionServiceRemark :detail="goodsItem" field="mechanic_remark" />
              </li>
            </ul>
          </div>
        </div>
      </div>

    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 删除数据
      datas: {
        update_reason: '',
        serviceDetail: []
      },
      tableData: [],
      delDialogVisible: false,
      updateType: 'complete',
    };
  },
  computed: {
    dialogTitle() {
      return this.updateType == 'should'
        ? this.$t('message.changeRequiredOperationQuantity')
        : this.$t('message.updateQuantity')
    },
  },
  methods: {
    // complete修改实际完成数；should修改需要操作数，同一弹窗复用商品信息布局。
    open(updateType, tableData, serviceSn) {
      this.updateType = updateType
      this.tableData = JSON.parse(JSON.stringify(tableData))
      this.datas = {
        service_sn: serviceSn,
        update_reason: '',
        serviceDetail: [],
      }
      this.delDialogVisible = true
    },
    // 修改勾选商品的需要操作数量。
    updateShouldDetail() {
      if (this.datas.update_reason == '') return this.$message.error('请输入修改原因')
      this.datas.serviceDetail = []
      this.tableData.forEach(orderItem => {
        orderItem.option_service_detail.forEach(item => {
          this.datas.serviceDetail.push({
            id: item.id,
            extra_options: item.extra_options
          })
        })
      })
      const hasEmptyQuantity = this.datas.serviceDetail.some(item =>
        item.extra_options.some(extraItem => extraItem.should === '')
      )
      if (hasEmptyQuantity) {
        return this.$message.error(this.$t('message.enterRequiredOperationQuantity'))
      }

      this.$api.optionServiceApi.updateShouldDetail(this.datas).then((res) => {
        this.$message.success(res.msg)
        this.$parent.optionServiceList()
        this.delDialogVisible = false
      });
    },
    // 修改已完成服务单的实际完成数量。
    updateCompleteDetail() {
      if (this.datas.update_reason == '') return this.$message.error('请输入修改原因')
      this.datas.serviceDetail = []
      this.tableData.forEach(orderItem => {
        orderItem.option_service_detail.forEach(item => {
          this.datas.serviceDetail.push({
            id: item.id,
            extra_options: item.extra_options
          })
        })
      })
      const hasEmptyQuantity = this.datas.serviceDetail.some(item =>
        item.extra_options.some(extraItem => extraItem.complete === '')
      )
      if (hasEmptyQuantity) return this.$message.error('请输入处理数量')

      this.$api.optionServiceApi.updateCompleteDetail(this.datas).then((res) => {
        this.$message.success(res.msg)
        this.$parent.optionServiceList()
        this.delDialogVisible = false
      });
    },

    // 数量只允许非负整数；只有实际完成数受需要操作数上限约束。
    handleInput(item, field) {
      // 将输入值转换为数字，去除所有非数字字符
      let value = String(item[field]).replace(/\D/g, '');
      // 如果输入为空，则清空
      if (value === '') {
        item[field] = '';
      } else {
        // 转换为数字
        const number = parseInt(value, 10);
        // 确保是正整数
        if (isNaN(number) || number < 0) {
          item[field] = '';
        } else if (field == 'complete') {
          // 实际完成数量不能大于需要操作数量。
          const maxShould = parseInt(item.should, 10) || 0;
          if (number > maxShould) {
            item[field] = maxShould.toString();
          } else {
            item[field] = number.toString();
          }
        } else {
          item[field] = number.toString();
        }
      }
      this.$forceUpdate()
    },
  }
}
</script>
<style lang='scss' scoped>
.rowBox {
  display: flex;
  justify-content: space-between;
  margin: 20px;

  .label {
    width: 100px;
    line-height: 40px;
  }

  .val {
    width: 500px;
  }

  .btn {
    flex: 1;
    text-align: right;
  }
}

.table {
  ol {
    display: flex;
    font-size: 14px;
    height: 60px;
    background-color: #edeff4;
    color: #333;
    position: sticky;
    top: 0px;
    left: 240px;
    z-index: 99;


    li {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 20px;

    }
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      word-break: break-all;

      .template {
        text-align: left;
        width: 100%;

        .row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 6px;
          padding: 0 6px;

          &:nth-last-child(1) {
            margin-bottom: 0;
          }

          .num {
            color: #B4272D;
          }
        }
      }

      .option {
        .row {
          display: flex;
          line-height: 40px !important;
          margin-bottom: 12px;

          .label {
            width: 100px;
          }

          .input {
            width: 80px;
            margin: 0 10px;
          }

          .num {
            width: 60px;
            margin-right: 10px;

          }


        }
      }
    }

    .img {
      position: relative;

      img {
        width: 60px;
        height: 60px;
        border-radius: 4px;
      }


    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;


  }

  .numberOfgoodsItem {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .time {
      display: flex;
      width: 70px;
    }
  }

  .flex05 {
    flex: 0.5;
    position: relative;

    a {
      position: absolute;
      right: 0;
      top: 0;
      height: 20px;
      width: 20px;
      background-color: #f56c6c;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
      color: #fff;
    }

    label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 1.8;

    /deep/ .el-textarea__inner {
      height: 40px;
      padding: 0 2px;
      line-height: 18px;
    }
  }

  .flex3 {
    flex: 2.5;
  }

  .detail {
    margin-bottom: 12px;

    .head {
      padding: 0px 20px;
      border-radius: 4px 4px 0px 0px;
      background-color: #545467;
      font-size: 14px;
      color: #fff;

      .row {
        display: flex;
        padding: 12px 0;
        border-bottom: 1px solid #87879F;

        .checkbox {
          line-height: 40px;
          margin-right: 20px;
        }

        .show {
          cursor: pointer;
          font-size: 30px;
          display: flex;
          justify-content: center;
          align-items: center;

          /deep/.el-button--mini {
            padding: 3px 8px;
            background-color: #F6F6F6;
            color: #666;
            border: 1px solid #F6F6F6;
          }

          i {
            font-size: 16px;
          }
        }

        .item {
          display: flex;
          margin-left: 65px;
          line-height: 40px;

          .el-icon-copy-document {
            line-height: 40px;
          }

          span {
            margin-right: 10px;
          }

          .acli {
            cursor: pointer;
            color: #f9ff57;
            text-decoration: underline;
          }
        }
      }

      .total {
        display: flex;
        flex-wrap: wrap;
        padding: 12px 0;

        .label {
          margin-right: 60px;
        }

        .item {
          margin-right: 36px;

          span {
            margin-left: 10px;
            color: #F9FF57;
          }
        }
      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}
</style>
